module.exports = __webpack_public_path__ + "static/img/bg355.e5436b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg355.jpg
// module id = 4Tsp
// module chunks = 0